import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Config from '../.env.json'

Vue.config.productionTip = false

config = Config;

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')